import { useState } from 'react';
import { motion } from 'framer-motion';
import AnimatedSection from '../common/AnimatedSection';

// const services = [
//   {
//     title: 'Banking & Finance',
//     description: 'Comprehensive training in modern banking operations, risk management, compliance, and financial analysis for industry professionals.',
//     icon: (
//       <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
//         <path strokeLinecap="round" strokeLinejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z" />
//       </svg>
//     ),
//     features: ['Risk Management', 'Regulatory Compliance', 'Financial Modeling', 'Digital Banking'],
//     stat: '45+',
//     statLabel: 'Programs',
//   },
//   {
//     title: 'Technology Training',
//     description: 'Cutting-edge programs in software development, cybersecurity, cloud computing, AI/ML, and emerging fintech solutions.',
//     icon: (
//       <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
//         <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 0 0 2.25-2.25V6.75a2.25 2.25 0 0 0-2.25-2.25H6.75A2.25 2.25 0 0 0 4.5 6.75v10.5a2.25 2.25 0 0 0 2.25 2.25Z" />
//       </svg>
//     ),
//     features: ['Cloud Computing', 'Cybersecurity', 'AI & Machine Learning', 'Fintech Solutions'],
//     stat: '80+',
//     statLabel: 'Programs',
//   },
//   {
//     title: 'Education Training',
//     description: 'Professional development for educators, curriculum designers, and institutional leaders in the evolving education landscape.',
//     icon: (
//       <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
//         <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342" />
//       </svg>
//     ),
//     features: ['Curriculum Design', 'EdTech Integration', 'Leadership Programs', 'Assessment Methods'],
//     stat: '35+',
//     statLabel: 'Programs',
//   },
// ];

const ServiceCard = ({ service, index }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <AnimatedSection delay={index * 0.15}>
      <motion.div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        whileHover={{ y: -6 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
        className="relative rounded-3xl border border-dark/[0.04] bg-white overflow-hidden h-full group"
      >
        <div className={`absolute top-0 left-0 w-full h-1 transition-all duration-500 ${hovered ? 'bg-primary' : 'bg-transparent'}`} />

        <div className="p-8 md:p-10">
          {/* <div className="flex items-start justify-between mb-8">
            <div className={`w-16 h-16 rounded-2xl flex items-center justify-center transition-all duration-500 ${
              hovered ? 'bg-primary text-white shadow-lg shadow-primary/25' : 'bg-primary/[0.07] text-primary'
            }`}>
              {service.icon}
            </div>
            <div className="text-right">
              <div className="text-3xl font-extrabold text-primary/20 group-hover:text-primary/40 transition-colors">{service.stat}</div>
              <div className="text-[10px] text-dark/25 font-medium uppercase tracking-wider">{service.statLabel}</div>
            </div>
          </div> */}

          <h3 className="text-2xl font-bold text-dark">{service.title}</h3>
          <p className="mt-4 text-dark/45 leading-relaxed">{service.description}</p>

          <div className="mt-8 grid grid-cols-2 gap-3">
            {service.features.map((feature) => (
              <div key={feature} className="flex items-center gap-2.5">
                <div className="w-1.5 h-1.5 rounded-full bg-primary/40 flex-shrink-0" />
                <span className="text-[13px] text-dark/45 font-medium">{feature}</span>
              </div>
            ))}
          </div>

          <div className="mt-8 pt-6 border-t border-dark/[0.04]">
            <a
              href="#contact"
              className="inline-flex items-center gap-2 text-sm font-semibold text-dark/30 group-hover:text-primary transition-colors duration-300"
            >
              Explore Programs
              <svg className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
              </svg>
            </a>
          </div>
        </div>
      </motion.div>
    </AnimatedSection>
  );
};

const Services = ({data}) => {
  return (
    <section id="services" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-16">
          <AnimatedSection className="lg:col-span-7">
            <span className="inline-block px-4 py-1.5 bg-primary/[0.06] text-primary text-xs font-bold rounded-full tracking-widest uppercase mb-6">
              What We Offer
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-dark leading-tight tracking-tight">
              Transformative training<br />
              across <span className="text-primary">three pillars</span>
            </h2>
          </AnimatedSection>
          <AnimatedSection delay={0.1} className="lg:col-span-5">
            <p className="text-dark/45 text-lg leading-relaxed">
              We deliver industry-leading programs across three core disciplines,
              each designed to create measurable, real-world impact.
            </p>
          </AnimatedSection>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {data?.map((service, i) => (
            <ServiceCard key={i} service={service} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
